import { prop } from "../../decorators/property";

export class ReelItemModel extends Backbone.AssociatedModel {

    @prop() public Title: string;
    @prop() public Year: number;
    @prop() public Court: string;
    @prop() public Url: string;
    @prop() public Flag: string;
    @prop() public DisplayJurisdiction: string;
    @prop() public Categories: string[];
    @prop() public ItemType: ReelItemType;
    @prop() public HtmlContent: string;
    @prop() public DocKey: string;
    @prop() public Description: string;
    @prop() public Coverage: string;
    @prop() public Subscribed: boolean;
    @prop() public Type: string;
    constructor(options?) {
        super(options);
    }
}

export enum ReelItemType {
    SearchResult,
    Document,
    Resource,
    Product,
    Placeholder
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/models/reel-item.ts